import { BREAKPOINTS } from 'fitify-ui-onboarding/src/utils/styled'
import { createGlobalStyle, css } from 'styled-components'

const compactBannerStyles = css`
  #CybotCookiebotDialog[data-template='bottom'] {
    top: 100% !important;
    width: 100% !important;
    max-width: none !important;
    box-sizing: border-box !important;
    padding: 0.5rem 1rem calc(0.75rem + env(safe-area-inset-bottom, 0px)) !important;
    border-radius: ${({ theme }) =>
      `${theme.radius['Radius XL']}px ${theme.radius['Radius XL']}px 0 0`} !important;

    @media ${BREAKPOINTS.MD} {
      top: calc(
        100% - ${({ theme }) => theme.sizes.contentHorizontalPadding}rem
      ) !important;
      max-width: 35rem !important;
      padding: 1rem !important;
      border-radius: ${({ theme }) => theme.radius['Radius XL']}px !important;
    }
  }

  #CybotCookiebotDialog[data-template='bottom']
    #CybotCookiebotDialogBodyContentTitle {
    margin-bottom: 0.25rem !important;
    font-size: 1.125rem !important;

    @media ${BREAKPOINTS.MD} {
      margin-bottom: 0.5rem !important;
      font-size: 1.25rem !important;
    }
  }

  #CybotCookiebotDialog[data-template='bottom']
    #CybotCookiebotDialogBodyContentText,
  #CybotCookiebotDialog[data-template='bottom']
    #CybotCookiebotDialogBodyContentText
    p,
  #CybotCookiebotDialog[data-template='bottom']
    #CybotCookiebotDialogBodyContentText
    span {
    font-size: 0.8125rem !important;
    line-height: 1.4 !important;

    @media ${BREAKPOINTS.MD} {
      font-size: 0.875rem !important;
      line-height: 1.5 !important;
    }
  }

  #CybotCookiebotDialog[data-template='bottom']
    .CybotCookiebotDialogBodyBottomWrapper {
    margin-top: 0 !important;

    @media ${BREAKPOINTS.MD} {
      margin-top: 12px !important;
    }
  }

  #CybotCookiebotDialog[data-template='bottom'] .CybotCookiebotScrollArea {
    margin-top: 0.5rem !important;

    @media ${BREAKPOINTS.MD} {
      margin-top: 12px !important;
    }
  }

  #CybotCookiebotDialog[data-template='bottom']
    .CybotCookiebotDialogBodyButton {
    min-width: 0 !important;
    min-height: 44px !important;
    max-height: none !important;
    padding: 0.625rem 0.75rem !important;
    line-height: 1.25 !important;
    overflow-wrap: anywhere !important;
    white-space: normal !important;

    @media ${BREAKPOINTS.MD} {
      min-width: auto !important;
      min-height: auto !important;
      max-height: 48px !important;
      padding: 0.75rem !important;
      line-height: normal !important;
      overflow-wrap: normal !important;
      white-space: nowrap !important;
    }
  }

  #CybotCookiebotDialog[data-template='bottom']
    #CybotCookiebotDialogBodyLevelButtonCustomize {
    min-height: 44px !important;
    padding: 0.625rem 0.75rem !important;

    @media ${BREAKPOINTS.MD} {
      min-height: auto !important;
      padding: 4px 0 !important;
    }
  }

  /* Cookiebot makes the body scrollable in short in-app-browser viewports.
     Keep that access to the full copy, but avoid the native white bar. */
  #CybotCookiebotDialog[data-template='bottom'] #CybotCookiebotDialogBody {
    scrollbar-color: ${({ theme }) => theme.colors['N Outline/Primary']}
      transparent !important;
    scrollbar-width: thin !important;

    @media ${BREAKPOINTS.MD} {
      scrollbar-color: auto !important;
      scrollbar-width: auto !important;
    }
  }

  #CybotCookiebotDialog[data-template='bottom']
    #CybotCookiebotDialogBody::-webkit-scrollbar {
    width: 4px;

    @media ${BREAKPOINTS.MD} {
      width: initial;
    }
  }

  #CybotCookiebotDialog[data-template='bottom']
    #CybotCookiebotDialogBody::-webkit-scrollbar-track {
    background: transparent;

    @media ${BREAKPOINTS.MD} {
      background: initial;
    }
  }

  #CybotCookiebotDialog[data-template='bottom']
    #CybotCookiebotDialogBody::-webkit-scrollbar-thumb {
    border-radius: ${({ theme }) => theme.radius['Radius FULL']}px;
    background: ${({ theme }) => theme.colors['N Outline/Primary']};

    @media ${BREAKPOINTS.MD} {
      border-radius: initial;
      background: initial;
    }
  }
`

const compactCleanStyles = css`
  #CybotCookiebotDialog[data-template='bottom'] #CybotCookiebotDialogHeader {
    display: none !important;

    @media ${BREAKPOINTS.MD} {
      display: flex !important;
    }
  }

  #CybotCookiebotDialog[data-template='bottom']
    #CybotCookiebotDialogBodyEdgeMoreDetails {
    display: none !important;

    @media ${BREAKPOINTS.MD} {
      display: flex !important;
    }
  }
`

const compactSideBySideStyles = css`
  #CybotCookiebotDialog[data-template='bottom']
    #CybotCookiebotDialogBodyButtonsWrapper {
    flex-direction: row !important;
    flex-wrap: wrap !important;

    @media ${BREAKPOINTS.MD} {
      flex-wrap: nowrap !important;
    }

    @media ${BREAKPOINTS.MD} and (max-width: 1279px) {
      flex-direction: column-reverse !important;
    }

    @media (min-width: 1280px) {
      flex-direction: row !important;
    }
  }

  #CybotCookiebotDialog[data-template='bottom']
    #CybotCookiebotDialogBodyLevelButtonLevelOptinAllowAll,
  #CybotCookiebotDialog[data-template='bottom']
    #CybotCookiebotDialogBodyLevelButtonCustomize {
    width: auto !important;
    min-width: 0 !important;
    flex: 1 1 10rem !important;
    flex-shrink: 1 !important;

    @media ${BREAKPOINTS.MD} {
      width: 100% !important;
      min-width: auto !important;
      flex: 0 1 auto !important;
    }
  }

  #CybotCookiebotDialog[data-template='bottom']
    #CybotCookiebotDialogBodyLevelButtonCustomize {
    border: 1px solid ${({ theme }) => theme.colors['N Content/Primary']} !important;
    color: ${({ theme }) => theme.colors['N Content/Primary']} !important;

    @media ${BREAKPOINTS.MD} {
      border: none !important;
      color: ${({ theme }) => theme.colors['N Content/Secondary']} !important;
    }
  }
`

const titleHiddenStyles = css`
  #CybotCookiebotDialog[data-template='bottom']
    #CybotCookiebotDialogBodyContentTitle {
    display: none !important;
    @media ${BREAKPOINTS.MD} {
      display: block !important;
    }
  }
`

export const CookieBotGlobalStyle = createGlobalStyle<{
  $bannerStyle: string
}>`
  /* ── Dialog container ──────────────────────────────────────────────── */
  #CybotCookiebotDialog {
    position: fixed !important;
    width: calc(100% - 32px) !important;
    min-width: auto !important;
    max-width: 35rem !important;
    flex-direction: column !important;
    padding: 1rem !important;
    border: none !important;
    border-radius: ${({ theme }) => theme.radius['Radius XL']}px !important;
    background: ${({ theme }) => theme.colors['N Surface/Primary']} !important;
    box-shadow: 0 0 24px rgba(0, 0, 0, 0.24) !important;
    font-family: 'Poppins', sans-serif !important;

    @media ${BREAKPOINTS.MD} {
      min-width: auto !important;
    }
  }

  #CybotCookiebotDialogHeaderLogosWrapper svg {
     fill: ${({ theme }) => theme.colors['N Content/Primary']} !important;
  }

  /* ── Compact / bottom banner state ────────────────────────────────── */
  #CybotCookiebotDialog[data-template="bottom"] {
    top: calc(100% - 16px) !important;
    transform: translate(-50%, -100%) !important;
  }

  /* ── Expanded / details modal state ───────────────────────────────── */
  #CybotCookiebotDialog[data-template="popup"] {
    top: 50% !important;
  }

  /* ── Tab content area must fill remaining space and allow inner scroll */
  #CybotCookiebotDialogTabContentDetails {
    min-height: 0 !important;
    flex: 1 !important;
  }

  /* Hide Cookiebot's decorative background watermark */
  #CybotCookiebotDialog > div[style*="position: absolute"] {
    display: none !important;
  }

  /* ── Scroll faders — must match white background ───────────────────── */
  .CybotCookiebotFader {
    background-image: linear-gradient(
      to top,
      ${({ theme }) => theme.colors['N Surface/Primary']},
      rgba(255, 255, 255, 0)
    ) !important;
  }

  .CybotCookiebotFaderLeft {
    background-image: linear-gradient(
      to right,
      ${({ theme }) => theme.colors['N Surface/Primary']},
      rgba(255, 255, 255, 0)
    ) !important;
  }

  .CybotCookiebotFaderRight {
    background-image: linear-gradient(
      to left,
      ${({ theme }) => theme.colors['N Surface/Primary']},
      rgba(255, 255, 255, 0)
    ) !important;
  }

  /* ── Header / logo ─────────────────────────────────────────────────── */
  #CybotCookiebotDialogHeader {
    display: flex !important;
    width: auto !important;
    align-self: flex-end !important;
    justify-content: flex-end !important;
    padding: 0 !important;
    border-bottom: none !important;
  }

  #CybotCookiebotDialogPoweredbyLink {
    display: flex !important;
    align-items: center !important;
  }

  #CybotCookiebotDialogPoweredbyCybot {
    width: auto !important;
    margin: 0 !important;
  }

  /* ── Content wrapper ───────────────────────────────────────────────── */
  .CybotCookiebotDialogContentWrapper {
    display: flex !important;
    min-height: 0 !important;
    flex: 1 !important;
    flex-direction: column !important;
  }

  #CybotCookiebotDialogTabContent {
    display: flex !important;
    min-height: 0 !important;
    flex: 1 !important;
    flex-direction: column !important;
    padding: 0 !important;
    margin: 0 !important;
  }

  .CybotCookiebotScrollContainer {
    padding: 0 !important;
    border: none !important;
    color: ${({ theme }) => theme.colors['N Content/Secondary']} !important;
  }

  #CybotCookiebotDialogBodyContent {
    padding: 0 !important;
  }

  /* ── Title ─────────────────────────────────────────────────────────── */
  #CybotCookiebotDialogBodyContentTitle {
    margin-bottom: 8px !important;
    color: ${({ theme }) => theme.colors['N Content/Primary']} !important;
    font-family: 'Poppins', sans-serif !important;
    font-size: 20px !important;
    font-weight: 500 !important;
    letter-spacing: -0.3px !important;
    line-height: 1.2 !important;
  }

  /* ── Body text ─────────────────────────────────────────────────────── */
  #CybotCookiebotDialogBodyContentText,
  #CybotCookiebotDialogBodyContentText p,
  #CybotCookiebotDialogBodyContentText span {
    color: ${({ theme }) => theme.colors['N Content/Secondary']} !important;
    font-family: 'Poppins', sans-serif !important;
    font-size: 14px !important;
    font-weight: 400 !important;
    line-height: 1.5 !important;
    white-space: normal !important;
  }

  /* ── "Show details" link ───────────────────────────────────────────── */
  #CybotCookiebotDialogBodyEdgeMoreDetails {
    height: auto !important;
    justify-content: flex-start !important;
    margin: 0 !important;

    @media ${BREAKPOINTS.MD} {
      margin-top: 4px !important;
    }
  }

  #CybotCookiebotDialogBodyEdgeMoreDetailsLink {
    color: ${({ theme }) => theme.colors['N Content/Secondary']} !important;
    font-family: 'Poppins', sans-serif !important;
    font-size: 14px !important;
    font-weight: 500 !important;
    text-decoration: none !important;

    &::after {
      border-color: ${({ theme }) => theme.colors['N Content/Secondary']} !important;
    }
  }

  #CybotCookiebotDialogBodyEdgeMoreDetailsLink:hover {
    text-decoration: underline !important;
  }

  /* ── Bottom wrapper spacing ────────────────────────────────────────── */
  .CybotCookiebotDialogBodyBottomWrapper {
    align-items: flex-end !important;
    padding: 0 !important;
    margin-top: 4px !important;

    @media ${BREAKPOINTS.MD} {
      margin-top: 12px !important;
    }
  }

  /* ── Cookie level toggles (when expanded) ──────────────────────────── */
  #CybotCookiebotDialogBodyLevelWrapper {
    margin-bottom: 8px !important;
  }

  .CybotCookiebotDialogBodyLevelButtonLabel {
    color: ${({ theme }) => theme.colors['N Content/Primary']} !important;
    font-family: 'Poppins', sans-serif !important;
    font-size: 14px !important;
    font-weight: 500 !important;
  }

  .CybotCookiebotDialogBodyLevelButtonDescription {
    color: ${({ theme }) => theme.colors['N Content/Secondary']} !important;
    font-family: 'Poppins', sans-serif !important;
    font-size: 14px !important;
    font-weight: 400 !important;
  }

  /* ── Footer / buttons container ────────────────────────────────────── */
  #CybotCookiebotDialogFooter {
    position: relative !important;
    z-index: 10 !important;
    width: 100% !important;
    padding: 0 !important;
    border: none !important;
  }

  .CybotCookiebotScrollArea {
    position: relative !important;
    z-index: 10 !important;
    padding: 0 !important;
    margin-top: 12px !important;
  }

  #CybotCookiebotDialogBodyButtons {
    max-width: none !important;
    padding: 0 !important;
  }

  /* Default view: buttons stacked */
  #CybotCookiebotDialogBodyButtonsWrapper {
    display: flex !important;
    width: 100% !important;
    gap: 8px !important;
    @media (min-width: 600px) and (max-width: 1279px) {
      flex-direction: column-reverse !important;
    }
  }

  /* Safari flex cross-axis bug: flex-shrink:1 prevents the Allow All button
     from stretching to full width on initial render in column/column-reverse
     layouts. Scoped to max-width:1279px (stacked layouts only) to avoid
     breaking the side-by-side row layout at ≥1280px. */
  @media (max-width: 1279px) {
    #CybotCookiebotDialogBodyButtonsWrapper:not(:has(
      #CybotCookiebotDialogBodyButtonDecline:not(.CybotCookiebotDialogHide)
    )) #CybotCookiebotDialogBodyLevelButtonLevelOptinAllowAll {
      flex-shrink: 0 !important;
    }
  }

  /* Modal/details view: Decline becomes visible → switch to row */
  #CybotCookiebotDialogBodyButtonsWrapper:has(
    #CybotCookiebotDialogBodyButtonDecline:not(.CybotCookiebotDialogHide)
  ) {
    flex-direction: row-reverse !important;
    gap: 12px !important;

    @media (min-width: 600px) {
      flex-direction: row !important;
    }
  }

  #CybotCookiebotDialogBodyButtons .CybotCookiebotDialogBodyButton:not(:first-of-type) {
    margin: 0 !important;
  }

  /* ── Shared button base ────────────────────────────────────────────── */
  .CybotCookiebotDialogBodyButton {
    width: 100% !important;
    max-width: none !important;
    max-height: 48px !important;
    padding: 0.75rem !important;
    border: none !important;
    border-radius: ${({ theme }) => theme.radius['Radius FULL']}px !important;
    cursor: pointer !important;
    font-family: 'Poppins', sans-serif !important;
    font-size: 16px !important;
    font-weight: 600 !important;
  }

  /* ── OK / Allow All button ─────────────────────────────────────────── */
  #CybotCookiebotDialogBodyLevelButtonLevelOptinAllowAll {
    background: ${({ theme }) => theme.colors['N Content/Primary']} !important;
    color: ${({ theme }) => theme.colors['N Content/Inverse WB']} !important;
  }

  /* ── Decline / Deny button ─────────────────────────────────────────── */
  #CybotCookiebotDialogBodyButtonDecline {
    background: ${({ theme }) => theme.colors['N Surface/Primary']} !important;
    color: ${({ theme }) => theme.colors['N Content/Primary']} !important;
  }

  /* ── Customize button ──────────────────────────────────────────────── */
  #CybotCookiebotDialogBodyLevelButtonCustomize {
    height: auto !important;
    padding: 4px 0 !important;
    margin: 0 !important;
    background: transparent !important;
    color: ${({ theme }) => theme.colors['N Content/Secondary']} !important;
    font-size: 14px !important;
    font-weight: 500 !important;
    line-height: 1.4 !important;
    text-align: center !important;
  }

  /* ── Radio button ──────────────────────────────────────────────── */
  .CybotCookiebotDialogBodyLevelButtonSlider {
    background-color: ${({ theme }) => theme.colors['N Content/Primary']} !important;
    &::before {
      background-color: ${({ theme }) => theme.colors['N Surface/Primary']} !important;
    }
  }
  #CybotCookiebotDialog input:checked+.CybotCookiebotDialogBodyLevelButtonSlider {
    background-color: ${({ theme }) => theme.colors['N Content/Secondary']} !important;
  }

  /* Hide the arrow icon inside Customize button */
  #CybotCookiebotDialogBodyLevelButtonCustomize > .CybotCookiebotDialogArrow {
    display: none !important;
  }

  /* ── Nav tabs (Details modal) ──────────────────────────────────────── */
  #CybotCookiebotDialogNav {
    border-bottom: none !important;
  }

  .CybotCookiebotDialogNavItemLink {
    border-bottom-color: ${({ theme }) => theme.colors['N Outline/Secondary']} !important;
    color: ${({ theme }) => theme.colors['N Content/Primary']} !important;
    font-family: 'Poppins', sans-serif !important;
    font-size: 14px !important;

    &[aria-selected="true"], &.CybotCookiebotDialogActive {
      border-bottom-color: ${({ theme }) => theme.colors['N Content/Primary']} !important;
      color: ${({ theme }) => theme.colors['N Content/Primary']} !important;
    }
  }

  /* ── Cookie dialog detail body (Details modal) ──────────────── */
  .CookieCard {
    border-color: ${({ theme }) => theme.colors['N Outline/Secondary']} !important;
  }

  .CybotCookiebotDialogDetailBodyContentCookieContainerButton, .CybotCookiebotDialogDetailBodyContentCookieProvider {
    color: ${({ theme }) => theme.colors['N Content/Primary']} !important;

    &::before {
      border-color: ${({ theme }) => theme.colors['N Content/Primary']} !important;
    }

    .CybotCookiebotDialogDetailBulkConsentCount {
      background: ${({ theme }) => theme.colors['N Surface/Secondary']} !important;
    }
  }

  .CybotCookiebotDialogDetailBodyContentCookieInfoWrapper::before {
    border-color: ${({ theme }) => theme.colors['N Outline/Secondary']} !important;
  }

  .CybotCookiebotDialogDetailBodyContentCookieLink {
    color: ${({ theme }) => theme.colors['N Content/Secondary']} !important;
  }

  .CybotCookiebotDialogDetailBodyContentCookieGroup, .CybotCookiebotDialogDetailBodyContentCookieInfo {
    border-color: ${({ theme }) => theme.colors['N Outline/Secondary']} !important;

    b, strong {
      color: ${({ theme }) => theme.colors['N Content/Primary']} !important;
    }

    a::after {
      border-color: ${({ theme }) => theme.colors['N Content/Primary']} !important;
    }

    .CybotCookiebotDialogDetailBodyContentCookieInfo {
      background: ${({ theme }) => theme.colors['N Surface/Secondary']} !important;

      .CybotCookiebotDialogDetailBodyContentCookieInfoFooter {
        border-color: ${({ theme }) => theme.colors['N Outline/Primary']} !important;
      }
    }
  }

  #CybotCookiebotDialogDetailBulkConsent {
    border-color: ${({ theme }) => theme.colors['N Outline/Secondary']} !important;

    #CybotCookiebotDialogDetailBulkConsentLink {
      color: ${({ theme }) => theme.colors['N Content/Primary']} !important;

      &::after {
        border-color: ${({ theme }) => theme.colors['N Content/Primary']} !important;
      }

      .CybotCookiebotDialogDetailBulkConsentCount {
        background: ${({ theme }) => theme.colors['N Surface/Secondary']} !important;
      }
    }

    #CybotCookiebotDialogDetailBulkConsentListWrapper {
      border-color: ${({ theme }) => theme.colors['N Outline/Secondary']} !important;

      span {
        border-color: ${({ theme }) => theme.colors['N Outline/Secondary']} !important;
        color: ${({ theme }) => theme.colors['N Content/Primary']} !important;
      }

      a {
        color: ${({ theme }) => theme.colors['N Content/Primary']} !important;
      }
    }
  }

  #CybotCookiebotDialogDetailFooter {
    a {
      color: ${({ theme }) => theme.colors['N Content/Primary']} !important;
    }
  }

  .CybotExternalLinkArrow {
    display: none !important;
  }

  ${({ $bannerStyle }) => {
    switch ($bannerStyle) {
      case 'compact_branded':
        return compactBannerStyles
      case 'compact_clean':
        return css`
          ${compactBannerStyles}
          ${compactCleanStyles}
        `
      case 'compact_minimal':
        return css`
          ${compactBannerStyles}
          ${compactCleanStyles}
          ${compactSideBySideStyles}
          ${titleHiddenStyles}
        `
      case 'black_with_logo':
      default:
        return undefined
    }
  }}
`
